<template>
  <div>
    <v-app id="inspire">
      <v-content>
        <v-row align="center" justify="center">
          <v-col sm="11" xs="11" md="11" lg="10" xl="10">
            <v-toolbar color="secondary">
              <v-toolbar-title>Revendedores</v-toolbar-title>
              <v-spacer></v-spacer>
              <c-formulario-usuarios
                :listaClientes="listaClientes"
                @carregarDados="carregarDados($event)"
                :dialog="dialog"
                :urlPost="'/api/v1/usuarios'"
                :usuarioEditado="usuarioEditado"
              ></c-formulario-usuarios>
            </v-toolbar>
            <c-lista-usuarios
              @deletar="abirModalExcluir($event)"
              @editar="editarRevendedor($event)"
              :carregando="carregando"
              :headers="headers"
              :itens="usuarios"
            ></c-lista-usuarios>
          </v-col>
        </v-row>
      </v-content>
    </v-app>

    <!--Modal para excluir-->
    <c-dialog-excluir
      :loaderExcluir="loaderExcluirUsuarioMultiedro"
      :dialogModalExcluir="dialogModalExcluir"
      :txtModal="'Tem certeza que deseja excluir este item?'"
      @fecharDialog="dialogModalExcluir = false"
      @apagarRevendedor="apagarRevendedor()"
    ></c-dialog-excluir>
    <!--The end-->
  </div>
</template>

<script>
import { apagar, receber } from "../mixins/RequisicaoMixin.js";
import { headersPadrao } from "../mixins/HeadersMixin.js";
import DialogExcluir from "../components/usuarios/DialogExcluir";
import ListaUsuarios from "../components/usuarios/ListaUsuarios";
import FormularioUsuarios from "../components/usuarios/FormularioUsuarios";

export default {
  components: {
    "c-dialog-excluir": DialogExcluir,
    "c-lista-usuarios": ListaUsuarios,
    "c-formulario-usuarios": FormularioUsuarios,
  },
  data: () => ({
    dialog: false,
    loaderExcluirUsuarioMultiedro: false,
    dialogModalExcluir: false,
    headers: [
      { text: "Nome", value: "nome" },
      { text: "E-mail", value: "email" },
      { text: "Papel", value: "papel" },
      { text: "Ação", value: "acao", align: "center", sortable: false },
    ],
    usuarios: [],
    usuarioEditado: {},
    excluirUsuario: {},
    listaClientes: [],
    carregando: false,
  }),

  async created() {
    await this.carregarDados();
    await this.carregaClientes();
  },

  methods: {
    async carregarDados() {
      this.carregando = true;
      const headers = headersPadrao();
      this.usuarios = [];
      await receber("api/v1/usuarios", headers)
        .then((resposta) => {
          this.filtrarUsuarios(resposta);
        })
        .catch((erro) => console.error(erro))
        .finally(() => (this.carregando = false));
    },
    async carregaClientes() {
      const headers = headersPadrao();
      await receber("api/v1/clientes", headers)
        .then((resposta) => {
          this.listaClientes = resposta;
        })
        .catch((erro) => console.error(erro));
    },
    editarRevendedor(item) {
      const headers = headersPadrao();
      receber(`api/v1/usuarios/${item.id}`, headers)
        .then((resposta) => {
          this.usuarioEditado = resposta;
        })
        .catch((erro) => {
          this.$store.commit(
            "atualizarMensagemDeErro",
            JSON.parse(erro.request.response).debugMessage
          );
          this.$store.commit("erro");
        });
    },
    salvarDadosDeUsuario(item) {
      if (item === false) {
        const headers = headersPadrao();
        receber("api/v1/usuarios", headers)
          .then((resposta) => {
            this.usuarios = resposta;
          })
          .catch((erro) => console.error(erro));
        return false;
      } else {
        this.usuarios.push(item);
      }
    },
    abirModalExcluir(item) {
      this.dialogModalExcluir = true;
      this.excluirUsuario = item;
    },
    apagarRevendedor() {
      this.carregando = true;
      this.loaderExcluirUsuarioMultiedro = true;
      const urlApagar = `api/v1/usuarios/${this.excluirUsuario.id}`;
      const headers = headersPadrao();

      apagar(urlApagar, headers)
        .then(() => {
          this.dialogModalExcluir = false;
          receber("api/v1/usuarios", headers)
            .then((resposta) => {
              this.usuarios = [];
              this.filtrarUsuarios(resposta);
            })
            .catch((erro) => console.error(erro));
        })
        .catch((erro) => new Error(erro))
        .finally(() => {
          this.carregando = false;
          this.loaderExcluirUsuarioMultiedro = false;
        });
    },
    filtrarUsuarios(resposta) {
      let filtrar = resposta.filter(
        (item) => item.papel != "ADMINISTRADOR" && item.papel != "CLIENTE"
      );
      this.usuarios.push(...filtrar);
    },
  },
};
</script>
